import React from 'react'

import { useTranslation } from 'react-i18next'
import { DefiDatagotchiCallout } from '@components/DefiDatagotchiCallout/DefiDatagotchiCallout'
import './ResultPageFooter.scss'

type Props = {
  /** Intermediate multi-survey (EQUE26 A→B) must not advertise the simulator yet. */
  variant?: 'simulator' | 'continue'
  actionLabel?: string
  onAction?: () => void
}

export const ResultPageFooter = ({ variant = 'simulator', actionLabel, onAction }: Props) => {
  const { t } = useTranslation('Result')
  return (
    <div className="ResultPageFooter">
      <DefiDatagotchiCallout className="ResultPageFooter-defi DefiDatagotchiCallout--flushAction">
        <p>{t(variant === 'continue' ? 'questionTextContinue' : 'questionTextSimulator')}</p>
        {actionLabel && onAction ? (
          <button type="button" className="DefiDatagotchiCallout-action" onClick={onAction}>
            {actionLabel}
          </button>
        ) : null}
      </DefiDatagotchiCallout>
    </div>
  )
}
